/**
 * Returns true when both arrays contain exactly the same set of items,
 * ignoring order and duplicate entries. Comparison is done via unique sets,
 * so [1, 1, 2] and [2, 1] are considered to contain the same items.
 */
export const doArraysContainSameItems = (arr1, arr2) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  if (set1.size !== set2.size) {
    return false;
  }
  return [...set1].every(item => set2.has(item));
};